import React from 'react';
import { render } from 'react-dom';
import { __ } from '@wordpress/i18n';


import { CalculatorIntake } from '../../calculators/components/Calculator/CalculatorIntake';

const allStrings = [
  __('Neutered adult', 'cooperpetcare'),
  __('Intact adult', 'cooperpetcare'),
  __('Inactive/obese prone', 'cooperpetcare'),
  __('Weight loss', 'cooperpetcare'),
  __('Weight gain (mild)', 'cooperpetcare'),
  __('Weight gain', 'cooperpetcare'),
  __('Active/working dog (mild)', 'cooperpetcare'),
  __('Active/working dog (moderate)', 'cooperpetcare'),
  __('Active/working dog (high intensity)', 'cooperpetcare'),
  __('Puppy 0-4 months', 'cooperpetcare'),
  __('Puppy 4 months to adult', 'cooperpetcare'),
  __('Kitten', 'cooperpetcare'),
  __('Neutered adult', 'cooperpetcare'),
  __('Intact adult', 'cooperpetcare'),
  __('Inactive/obese prone', 'cooperpetcare'),
  __('Weight loss', 'cooperpetcare'),
  __('Daily Calorie Intake Recommendation:', 'cooperpetcare'),
  __('Daily Calorie Intake Calculator', 'cooperpetcare'),
  __('Life stage:', 'cooperpetcare'),
  __('Please select an option', 'cooperpetcare'),
  __('Weight of the pet (kg):', 'cooperpetcare'),  __('Weight of your pet in kilograms', 'cooperpetcare'),
  __('Calculate', 'cooperpetcare'),
  __('Callories', 'cooperpetcare'),
]

const blockWrapperClass = 'block-container__' + 'calc-intake';
const wrappers = document.getElementsByClassName(blockWrapperClass);

for (let wrapper of wrappers) {
  render(<CalculatorIntake />, wrapper);
}
